import type { components } from '@social-studio/operator-client';
import { useInfiniteQuery } from '@tanstack/react-query';
import { api, call } from '../../lib/api';

export type LogEvent = components['schemas']['OperatorLogEventDto'];
export interface AuditFilter {
  readonly action: string;
  readonly operatorId: string;
}

/** Every action key the log can hold (API `operator-audit.ts`); the filter offers them in this order. */
export const AUDIT_ACTIONS = [
  'tenant.viewed',
  'tenant.suspended',
  'tenant.unsuspended',
  'tenant.industry_profile_changed',
  'tenant.billing_viewed',
  'tenant.credits_adjusted',
  'tenant.billing_mode_changed',
  'tenant.trial_extended',
  'operator.sign_in_succeeded',
  'operator.sign_in_failed',
  'operator.second_factor_failed',
  'operator.signed_out',
  'operator.created',
  'operator.updated',
  'operator.invitation_sent',
  'operator.password_set',
  'operator.totp_confirmed',
] as const;

/** What operators did across all tenants, newest first, narrowed by action and operator (REQ-140-005). */
export function useAuditLog(filter: AuditFilter) {
  return useInfiniteQuery({
    queryKey: ['operator-audit-log', filter],
    initialPageParam: undefined as string | undefined,
    queryFn: ({ pageParam }) =>
      call(() =>
        api.GET('/v1/operator/audit', {
          params: {
            query: {
              limit: 50,
              ...(filter.action ? { action: filter.action } : {}),
              ...(filter.operatorId ? { operator_id: filter.operatorId } : {}),
              ...(pageParam ? { cursor: pageParam } : {}),
            },
          },
        }),
      ),
    getNextPageParam: (page) => page.next_cursor ?? undefined,
  });
}
